module.exports = __webpack_public_path__ + "static/media/Hoist_ios_1_preview.e7dbf4e1.jpg";